import React from "react"
import { injectIntl } from "react-intl"
import BaseStatBox from "../../../common/statbox/BaseStatBox"
import IntlProps from "../../../state/helpers/IntlProps"
import { messages } from "./messages"

type OwnProps = {
    amount: number
    currency: string
}

const StatBoxInTransitToBank = (props: OwnProps & IntlProps) => {

    return (
        <BaseStatBox
            title={props.intl.formatMessage(messages["inTransitToBankTitle"])}
            amount={props.amount}
            currency={props.currency}
            displayTooltip={true}
            tooltipMessage={props.intl.formatMessage(messages["inTransitToBankTooltipMessage"])}
            notes={props.intl.formatMessage(messages["estimatedAmounts"])}
        />
    )
}

export default injectIntl(StatBoxInTransitToBank)



// WEBPACK FOOTER //
// ./src/payment-processing/payout-listing/statBoxes/StatBoxInTransitToBank.tsx